import script from "./ChatModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChatModal.vue?vue&type=style&index=0&id=6de557d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de557d2"]])

export default __exports__